import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';
import { RecoveryTypesEnum } from './enums';
import { DateSerializer } from './date-serializer';

export class RecoveryTypes {
    id: string;
    businessKey: string;
    name: string;
    description: string;
    uiSortIndex: number;
    activateOn: moment.Moment;
    deactivateOn: moment.Moment;
    modalType: RecoveryTypesEnum;
    active: boolean;
    modifiedOn: moment.Moment;
    modifiedBy: string;

  public constructor(init?: Partial<RecoveryTypes>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root',
})
export class RecoveryTypesAdapter implements Adapter<RecoveryTypes> {
  adapt(item: any): RecoveryTypes {
    return new RecoveryTypes({
      id: item.id,
      businessKey: item.businessKey,
      name: item.name,
      description: item.description,
      uiSortIndex: item.uiSortIndex,
      activateOn: DateSerializer.deserialize(item.activateOn),
      active: item.active,
      modalType: item.modalType,
      deactivateOn: DateSerializer.deserialize(item.deactivateOn),
      modifiedOn: DateSerializer.deserialize(item.modifiedOn),
      modifiedBy: item.modifiedBy,
    });
  }
}
